(function () {
  var headerGroup = document.querySelector('.shopify-section-group-header-group');
  var header      = document.querySelector('.header-wrapper');
  if (!headerGroup && !header) return;

  var isHomepage = document.body.classList.contains('template-index');
  var lastY      = window.scrollY;
  var THRESHOLD  = 30;   /* px desde el tope para activar fondo oscuro */
  var DELTA      = 6;    /* px mínimos de scroll para registrar dirección */
  var HIDE_START = window.innerHeight * 0.6; /* ocultar tras bajar 60vh del hero */

  function onScroll() {
    var y   = window.scrollY;
    var dir = y - lastY; /* positivo = bajando, negativo = subiendo */

    /* ── Fondo oscuro / transparente ── */
    if (!isHomepage || y > THRESHOLD) {
      if (headerGroup) headerGroup.classList.add('ls-scrolled');
      if (header)      header.classList.add('ls-has-bg');
    } else {
      if (headerGroup) headerGroup.classList.remove('ls-scrolled');
      if (header)      header.classList.remove('ls-has-bg');
    }

    /* ── Ocultar / mostrar según dirección de scroll ── */
    if (isHomepage && y > HIDE_START) {
      if (dir > DELTA) {
        /* Bajando → ocultar */
        if (headerGroup) headerGroup.classList.add('ls-hidden');
      } else if (dir < -DELTA) {
        /* Subiendo → mostrar */
        if (headerGroup) headerGroup.classList.remove('ls-hidden');
      }
    } else {
      /* En el hero o al llegar al tope: siempre visible */
      if (headerGroup) headerGroup.classList.remove('ls-hidden');
    }

    lastY = y;
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();
